import { Entity, Field } from "typegraph";

import { TagSet } from "./TagSet";

@Entity({one: "tag", many: "tags"})
export default class Tag {

	@Field()
	public id: string | number;

	@Field()
	public name: string;

	@Field({entity: TagSet})
	public tagSet: TagSet;

}



// WEBPACK FOOTER //
// ./src/panels/catalog/entities/Tag.ts